import React from 'react'
import PropTypes from 'prop-types'
import Swiper from 'templates/shared/components/ReactSwiper'

const ImageSwiper = ({ images }) => {
  const onImageLoad = (e) => {
    const imageWidth = e.target.naturalWidth
    const imageHeight = e.target.naturalHeight
    if (imageHeight > imageWidth) {
      e.target.classList.add('small-width')
    }
  }
  return (
    <Swiper
      id='image_swiper'
      resistance={false}
      speed={800}
      loop={false}
      containerClass='swiper-container ou_product-card__image'
      shouldSwiperUpdate
    >
      {images && images.map((image, index) => (
        <div className='slide' key={index}>
          <img height='100%' width='100%' onLoad={e => onImageLoad(e)} src={image} role='presentation' />
        </div>
      ))}
    </Swiper>
  )
}

ImageSwiper.propTypes = {
  images: PropTypes.array
}

export default ImageSwiper



// WEBPACK FOOTER //
// ./src/templates/outSide/components/products/ImageSwiper.js